import { GridColDef } from "@mui/x-data-grid";
import UpdateLenderPopup from "../../../components/Fleet/UpdateLenderPopup/UpdateLenderPopup";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";

export const lendersTableColumns: GridColDef[] = [
  { field: "name", headerName: "Name", width: 150 },
  { field: "email", headerName: "Email", width: 150 },
  { field: "phoneNumber", headerName: "Phone Number", width: 150 },
  {
    field: "actions",
    headerName: "",
    width: 200,
    renderCell: (params) => <UpdateLenderPopup lender={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) => (
      <ConfirmActionButton
        id={params.row.id}
        entityType="Lender"
        actionType="delete"
        entityLabel="lender"
        queryKey="lenders"
        buttonLabel="Delete"
        buttonColor="error"
      />
    ),
  },
];
